module.exports = __webpack_public_path__ + "img/paysu.56763af8.png";